import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Typography } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { CheckBox } from '@ds/react-components';
import Modal from 'common/dialog/Modal.js';
import TermsAndConditionsControls from './TermsAndConditionsControls';

const styles = (theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
    padding: '15px 15px',
  },
  body: {
    color: theme.palette.common.gray,
    fontSize: '14px',
  },
  title: {
    color: theme.palette.common.darkGray,
    fontSize: '26px',
    fontWeight: 'bold',
  },
  h2: {
    color: theme.palette.common.black,
    fontSize: '20px',
    fontWeight: 'bold',
  },
  h3: {
    color: theme.palette.common.black,
    fontSize: '16px',
    fontWeight: 'bold',
    padding: '15px 0px 10px 0px',
  },
  line: {
    borderRadius: '6px',
    borderTop: '1px solid rgba(0, 0, 0, 0.08)',
    margin: '0px -15px 0px -15px',
  },
  layoutPadding: {
    background: theme.palette.common.white,
    padding: theme.spacing(3),
  },
});

class TermsAndConditions extends React.PureComponent {
  render() {
    const {
      classes,
      showModal,
      hasAcceptedTC,
      scrolledToEnd,
      onClickDismiss,
      onClickAccept,
      onChangeAcceptTermsAndConditions,
      tcRead,
      tcAccpetChecked,
    } = this.props;

    let body = (
      <div>
        <p>
          <strong>Customer Portal Acceptable Use Policy</strong>
        </p>
        <p>
          <strong>
            <u>General </u>
          </strong>
        </p>
        <ol>
          <li>
            Use of the Customer Portal (&ldquo;Portal&rdquo;) is subject to this
            Acceptable Use Policy (&ldquo;Policy&rdquo;).
          </li>
          <li>
            This Policy sets out the terms between the Customer
            (&ldquo;you&rdquo;) and Debitsuccess (&ldquo;we&rdquo;,
            &ldquo;us&rdquo;, &ldquo;our&rdquo;) under which you may access our
            Portal.
          </li>
        </ol>
        <p>
          <strong>
            <u>Customer Responsibilities </u>
          </strong>
        </p>
        <ol start="3">
          <li>
            You agree that:
            <ul>
              <li>3.1 Your use of the Portal is at your own risk.</li>
              <li>
                3.2 You are responsible for the accuracy and completeness of
                your Personal Information contributed to the Portal
              </li>
              <li>
                3.3 You are responsible for the use of your account. You also
                agree that you are responsible for ensuring that anyone who
                accesses your account is aware of this Policy and complies with
                the Policy.
              </li>
              <li>
                3.4 If you are under 18 years of age, access to this Portal will
                be terminated with or without notice when you turn 18. You will
                be required to contact us to reinstate your access.
                <br />{' '}
              </li>
            </ul>
          </li>
        </ol>
        <p>
          <strong>
            <u>Prohibited Activities</u>
          </strong>
        </p>
        <ol start="4">
          <li>
            You agree not to use the Portal or allow the Portal to be used:
            <ul>
              <li>4.1 In any way that is harmful, deceptive or unlawful</li>
              <li>
                4.2 In any way to violate or encourage the violation of the
                rights of others; including but not limited to:
                <ul>
                  <li>4.2.1 Phishing or engaging in identity theft;</li>
                  <li>
                    4.2.2 Gaining access to an unauthorized area or account;
                  </li>
                  <li>
                    4.2.3 Accessing or using for any unlawful, invasive,
                    defamatory or fraudulent purpose;
                  </li>
                </ul>
              </li>
              <li>
                4.3 To intentionally or negligently distribute viruses, worms,
                trojan horses or other items of a destructive or deceptive
                nature;
              </li>
              <li>
                4.4 To disable, interfere with or circumvent any aspect of the
                Portal;
              </li>
              <li>
                4.5 To use the Portal or any interfaces provided with the Portal
                in a manner that violates the terms of services of any of
                Debitsuccess or Transaction Services Group (TSG) product or
                service.
              </li>
            </ul>
          </li>
        </ol>
        <p>
          <strong>
            <u>Indemnity</u>
          </strong>
        </p>
        <p>
          <span>Accuracy and reliability of data</span>
        </p>
        <ol start="5">
          <li>
            Whilst we take reasonable steps to make the Portal useful and
            secure, the Portal is provided as is, without warranty of any kind.
          </li>
          <li>
            We do not warrant that the Customer Portal will be secure,
            error-free, free from viruses or other malware, or any criteria of
            performance or quality.
          </li>
          <li>
            We expressly disclaim all implied warranties. We will take
            reasonable steps to ensure that the information therein is secure
            and accessible only to authorised persons.
          </li>
        </ol>
        <p>
          <span>Availability and accessibility of the Customer Portal</span>
        </p>
        <ol start="8">
          <li>
            Debitsuccess does not guarantee or warranty the availability of the
            Customer Portal or that the service will be error free or without
            disruption.
          </li>
          <li>
            There may be times when the services are not available at all or
            only in part.
          </li>
          <li>
            We reserve the right, at our discretion, to withdraw the Customer
            Portal from you in situations where uninterrupted use of the
            Customer Portal is or may be compromised.
          </li>
          <li>
            If you become aware that security may be threatened, you shall
            notify us immediately by telephone and email on{' '}
            <a href="mailto:compliance@transactionservices.global">
              compliance@transactionservices.global
            </a>
            .
          </li>
          <li>
            We will not be held liable for any damage or costs incurred by you
            (including for any indirect, incidental, special or consequential
            loss, even if such loss was reasonably foreseeable), including any
            limitation damage due to any malfunctions, errors, delays or any
            other deficiencies of the Customer Portal.
          </li>
        </ol>
        <p>
          <strong>
            <u>Enforcement</u>
          </strong>
        </p>
        <ol start="13">
          <li>
            Your account, access or use of the Customer Portal may be suspended
            or terminated with or without notice upon any violation of this
            policy.
          </li>
          <li>
            We reserve the right to take a legal action, if necessary, at all
            times.
          </li>
        </ol>
        <p>
          <strong>
            <u>Disclaimer</u>
          </strong>
        </p>
        <ol start="15">
          <li>
            We reserve the right to change this policy at any given time. If you
            want to make sure that you are up to date with the latest changes,
            we advise you to frequently visit this page.
          </li>
        </ol>
        <p>
          <strong>
            <u>Reporting</u>
          </strong>
        </p>
        <ol start="16">
          <li>
            To report a violation of this policy, please email us on{' '}
            <a href="mailto:compliance@transactionservices.global">
              compliance@transactionservices.global
            </a>{' '}
            immediately upon notice.
          </li>
        </ol>
        <p>&nbsp;</p>
      </div>
    );

    if (!showModal) {
      return (
        <div className={classes.layoutPadding}>
          <Typography variant="h2">
            Debitsuccess Website Terms and Conditions
          </Typography>
          <br />
          <hr className={classes.line} />
          <br />
          {body}
          <FormControlLabel
            disabled={true}
            value="end"
            control={<CheckBox checked={true} color="primary" />}
            label="I have read and understand the above terms and conditions"
            labelPlacement="end"
          />
        </div>
      );
    }

    return (
      <Modal
        title="Debitsuccess Terms and Conditions"
        type="large"
        message={body}
        open={!hasAcceptedTC}
        scrolledToEnd={scrolledToEnd}
        controls={
          <TermsAndConditionsControls
            tCCheckboxEnabled={tcRead}
            acceptButtonEnabled={tcAccpetChecked}
            onClickDismiss={onClickDismiss}
            onChangeAcceptTermsAndConditions={onChangeAcceptTermsAndConditions}
            onClickAccept={onClickAccept}
          />
        }
      />
    );
  }
}

TermsAndConditionsControls.propTypes = {
  showModal: PropTypes.bool,
  hasAcceptedTC: PropTypes.bool,
  scrolledToEnd: PropTypes.func,
  onClickDismiss: PropTypes.func,
  onClickAccept: PropTypes.func,
  onChangeAcceptTermsAndConditions: PropTypes.func,
  tcRead: PropTypes.bool,
  tcAccpetChecked: PropTypes.bool,
};

export default withStyles(styles, { withTheme: true })(TermsAndConditions);
